import { useState, useEffect } from 'react'
import { grantAnalyticsConsent } from '../analytics'

const STORAGE_KEY = 'impact-cookie-consent'

export function CookieConsent() {
  const [accepted, setAccepted] = useState<boolean | null>(null)

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      setAccepted(stored === 'true')
    } catch {
      setAccepted(false)
    }
  }, [])

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true')
    } catch {}
    grantAnalyticsConsent()
    setAccepted(true)
  }

  if (accepted === true) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10001] p-4 bg-[#1e232b]/98 border-t border-white/10 backdrop-blur-sm">
      <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-white/90 text-sm">
          We use cookies to improve your experience. By continuing you agree to our use of cookies.{' '}
          <a href="/privacy" className="text-[#cab6a1] underline hover:no-underline">Privacy Policy</a>
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 px-5 py-2.5 bg-[#cab6a1] text-[#1e232b] text-sm font-medium rounded hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#cab6a1]"
        >
          Accept
        </button>
      </div>
    </div>
  )
}
